export const CRAWL_NOT_STARTED = 0;
export const CRAWL_IN_PROGRESS = 1;
export const CRAWL_COMPLETED = 2;
export const CRAWL_ABORTED = 3;
export const CRAWL_PAUSED = 4;

export const CRAWL_TXT_NOT_STARTED = 'Not Started';
export const CRAWL_TXT_IN_PROGRESS = 'In Progress';
export const CRAWL_TXT_COMPLETED = 'Completed';
export const CRAWL_TXT_ABORTED = 'Aborted';
export const CRAWL_TXT_PAUSED = 'Paused';

export const FREE_PLAN_ID=2;
export const ADMIN_PLAN_ID=1;

export const isHttp = (str) => {
    return (str && str.toLowerCase().substring(0,4) === 'http')
}

export const getBgUrl = (ogImage, compLogo, gimgUrl) => {
    var bgUrl = '/business.png';
    if (isHttp(ogImage)) {
        bgUrl = ogImage;
    } else if (isHttp(compLogo)) {
        bgUrl = compLogo
    } else if (isHttp(gimgUrl)) {
        bgUrl = gimgUrl
    }
    return bgUrl
}

export const getBgSize = (ogImage, compLogo, gimgUrl) => {
    var bgSize = 'cover';
    if (isHttp(ogImage)) {
        bgSize = 'contain';
    } else if (isHttp(compLogo)) {
        bgSize = 'contain';
    } else if (isHttp(gimgUrl)) {
        bgSize = 'cover'
    }
    return bgSize
}

export const COUNTRIES_DATA = [
    { "value": 233, "label": "United States of America", "code": "US" },
    { "value": 105, "label": "India", "code": "IN" },
];

export const STATES_DATA = [
	{
		"value" : 577,
		"label" : "Andaman & Nicobar Islands",
		"countryid" : 105,
		"statecode" : "AN"
	},
	{
		"value" : 578,
		"label" : "Andhra Pradesh",
		"countryid" : 105,
		"statecode" : "AP"
	},
	{
		"value" : 579,
		"label" : "Arunachal Pradesh",
		"countryid" : 105,
		"statecode" : "AR"
	},
	{
		"value" : 580,
		"label" : "Assam",
		"countryid" : 105,
		"statecode" : "AS"
	},
	{
		"value" : 581,
		"label" : "Bihar",
		"countryid" : 105,
		"statecode" : "BR"
	},
	{
		"value" : 582,
		"label" : "Chandigarh",
		"countryid" : 105,
		"statecode" : "CH"
	},
	{
		"value" : 583,
		"label" : "Chattisgarh",
		"countryid" : 105,
		"statecode" : "CG"
	},
	{
		"value" : 584,
		"label" : "Dadra and Nagar Haveli and Daman and Diu",
		"countryid" : 105,
		"statecode" : "DH"
	},
	{
		"value" : 585,
		"label" : "Delhi",
		"countryid" : 105,
		"statecode" : "DL"
	},
	{
		"value" : 586,
		"label" : "Goa",
		"countryid" : 105,
		"statecode" : "GA"
	},
	{
		"value" : 587,
		"label" : "Gujarat",
		"countryid" : 105,
		"statecode" : "GJ"
	},
	{
		"value" : 588,
		"label" : "Haryana",
		"countryid" : 105,
		"statecode" : "HR"
	},
	{
		"value" : 589,
		"label" : "Himachal Pradesh",
		"countryid" : 105,
		"statecode" : "HP"
	},
	{
		"value" : 590,
		"label" : "Jammu & Kashmir",
		"countryid" : 105,
		"statecode" : "JK"
	},
	{
		"value" : 591,
		"label" : "Jharkhand",
		"countryid" : 105,
		"statecode" : "JH"
	},
	{
		"value" : 592,
		"label" : "Karnataka",
		"countryid" : 105,
		"statecode" : "KA"
	},
	{
		"value" : 593,
		"label" : "Kerala",
		"countryid" : 105,
		"statecode" : "KL"
	},
	{
		"value" : 594,
		"label" : "Lakshadweep",
		"countryid" : 105,
		"statecode" : "LD"
	},
	{
		"value" : 595,
		"label" : "Madhya Pradesh",
		"countryid" : 105,
		"statecode" : "MP"
	},
	{
		"value" : 596,
		"label" : "Maharashtra",
		"countryid" : 105,
		"statecode" : "MH"
	},
	{
		"value" : 597,
		"label" : "Manipur",
		"countryid" : 105,
		"statecode" : "MN"
	},
	{
		"value" : 598,
		"label" : "Meghalaya",
		"countryid" : 105,
		"statecode" : "ML"
	},
	{
		"value" : 599,
		"label" : "Mizoram",
		"countryid" : 105,
		"statecode" : "MZ"
	},
	{
		"value" : 600,
		"label" : "Nagaland",
		"countryid" : 105,
		"statecode" : "NL"
	},
	{
		"value" : 601,
		"label" : "Odisha",
		"countryid" : 105,
		"statecode" : "OD"
	},
	{
		"value" : 602,
		"label" : "Pondicherry",
		"countryid" : 105,
		"statecode" : "PY"
	},
	{
		"value" : 603,
		"label" : "Punjab",
		"countryid" : 105,
		"statecode" : "PB"
	},
	{
		"value" : 604,
		"label" : "Rajasthan",
		"countryid" : 105,
		"statecode" : "RJ"
	},
	{
		"value" : 605,
		"label" : "Sikkim",
		"countryid" : 105,
		"statecode" : "SK"
	},
	{
		"value" : 606,
		"label" : "Tamil Nadu",
		"countryid" : 105,
		"statecode" : "TN"
	},
	{
		"value" : 607,
		"label" : "Telangana",
		"countryid" : 105,
		"statecode" : "TS"
	},
	{
		"value" : 608,
		"label" : "Tripura",
		"countryid" : 105,
		"statecode" : "TR"
	},
	{
		"value" : 609,
		"label" : "Uttar Pradesh",
		"countryid" : 105,
		"statecode" : "UP"
	},
	{
		"value" : 610,
		"label" : "Uttarakhand",
		"countryid" : 105,
		"statecode" : "UK"
	},
	{
		"value" : 611,
		"label" : "West Bengal",
		"countryid" : 105,
		"statecode" : "WB"
	},
	{
		"value" : 1511,
		"label" : "Alabama",
		"countryid" : 233,
		"statecode" : "AL"
	},
	{
		"value" : 1512,
		"label" : "Alaska",
		"countryid" : 233,
		"statecode" : "AK"
	},
	{
		"value" : 1513,
		"label" : "Arizona",
		"countryid" : 233,
		"statecode" : "AZ"
	},
	{
		"value" : 1514,
		"label" : "Arkansas",
		"countryid" : 233,
		"statecode" : "AR"
	},
	{
		"value" : 1515,
		"label" : "California",
		"countryid" : 233,
		"statecode" : "CA"
	},
	{
		"value" : 1516,
		"label" : "Colorado",
		"countryid" : 233,
		"statecode" : "CO"
	},
	{
		"value" : 1517,
		"label" : "Connecticut",
		"countryid" : 233,
		"statecode" : "CT"
	},
	{
		"value" : 1518,
		"label" : "Delaware",
		"countryid" : 233,
		"statecode" : "DE"
	},
	{
		"value" : 1519,
		"label" : "District of Columbia",
		"countryid" : 233,
		"statecode" : "DC"
	},
	{
		"value" : 1520,
		"label" : "Florida",
		"countryid" : 233,
		"statecode" : "FL"
	},
	{
		"value" : 1521,
		"label" : "Georgia",
		"countryid" : 233,
		"statecode" : "GA"
	},
	{
		"value" : 1522,
		"label" : "Hawaii",
		"countryid" : 233,
		"statecode" : "HI"
	},
	{
		"value" : 1523,
		"label" : "Idaho",
		"countryid" : 233,
		"statecode" : "ID"
	},
	{
		"value" : 1524,
		"label" : "Illinois",
		"countryid" : 233,
		"statecode" : "IL"
	},
	{
		"value" : 1525,
		"label" : "Indiana",
		"countryid" : 233,
		"statecode" : "IN"
	},
	{
		"value" : 1526,
		"label" : "Iowa",
		"countryid" : 233,
		"statecode" : "IA"
	},
	{
		"value" : 1527,
		"label" : "Kansas",
		"countryid" : 233,
		"statecode" : "KS"
	},
	{
		"value" : 1528,
		"label" : "Kentucky",
		"countryid" : 233,
		"statecode" : "KY"
	},
	{
		"value" : 1529,
		"label" : "Louisiana",
		"countryid" : 233,
		"statecode" : "LA"
	},
	{
		"value" : 1530,
		"label" : "Maine",
		"countryid" : 233,
		"statecode" : "ME"
	},
	{
		"value" : 1531,
		"label" : "Marshall Islands",
		"countryid" : 233,
		"statecode" : "MH"
	},
	{
		"value" : 1532,
		"label" : "Maryland",
		"countryid" : 233,
		"statecode" : "MD"
	},
	{
		"value" : 1533,
		"label" : "Massachusetts",
		"countryid" : 233,
		"statecode" : "MA"
	},
	{
		"value" : 1534,
		"label" : "Michigan",
		"countryid" : 233,
		"statecode" : "MI"
	},
	{
		"value" : 1535,
		"label" : "Minnesota",
		"countryid" : 233,
		"statecode" : "MN"
	},
	{
		"value" : 1536,
		"label" : "Mississippi",
		"countryid" : 233,
		"statecode" : "MS"
	},
	{
		"value" : 1537,
		"label" : "Missouri",
		"countryid" : 233,
		"statecode" : "MO"
	},
	{
		"value" : 1538,
		"label" : "Montana",
		"countryid" : 233,
		"statecode" : "MT"
	},
	{
		"value" : 1539,
		"label" : "Nebraska",
		"countryid" : 233,
		"statecode" : "NE"
	},
	{
		"value" : 1540,
		"label" : "Nevada",
		"countryid" : 233,
		"statecode" : "NV"
	},
	{
		"value" : 1541,
		"label" : "New Hampshire",
		"countryid" : 233,
		"statecode" : "NH"
	},
	{
		"value" : 1542,
		"label" : "New Jersey",
		"countryid" : 233,
		"statecode" : "NJ"
	},
	{
		"value" : 1543,
		"label" : "New Mexico",
		"countryid" : 233,
		"statecode" : "NM"
	},
	{
		"value" : 1544,
		"label" : "New York",
		"countryid" : 233,
		"statecode" : "NY"
	},
	{
		"value" : 1545,
		"label" : "North Carolina",
		"countryid" : 233,
		"statecode" : "NC"
	},
	{
		"value" : 1546,
		"label" : "North Dakota",
		"countryid" : 233,
		"statecode" : "ND"
	},
	{
		"value" : 1547,
		"label" : "Ohio",
		"countryid" : 233,
		"statecode" : "OH"
	},
	{
		"value" : 1548,
		"label" : "Oklahoma",
		"countryid" : 233,
		"statecode" : "OK"
	},
	{
		"value" : 1549,
		"label" : "Oregon",
		"countryid" : 233,
		"statecode" : "OR"
	},
	{
		"value" : 1550,
		"label" : "Pennsylvania",
		"countryid" : 233,
		"statecode" : "PA"
	},
	{
		"value" : 1551,
		"label" : "Rhode Island",
		"countryid" : 233,
		"statecode" : "RI"
	},
	{
		"value" : 1552,
		"label" : "South Carolina",
		"countryid" : 233,
		"statecode" : "SC"
	},
	{
		"value" : 1553,
		"label" : "South Dakota",
		"countryid" : 233,
		"statecode" : "SD"
	},
	{
		"value" : 1554,
		"label" : "Tennessee",
		"countryid" : 233,
		"statecode" : "TN"
	},
	{
		"value" : 1555,
		"label" : "Texas",
		"countryid" : 233,
		"statecode" : "TX"
	},
	{
		"value" : 1557,
		"label" : "Utah",
		"countryid" : 233,
		"statecode" : "UT"
	},
	{
		"value" : 1558,
		"label" : "Vermont",
		"countryid" : 233,
		"statecode" : "VT"
	},
	{
		"value" : 1559,
		"label" : "Virginia",
		"countryid" : 233,
		"statecode" : "VA"
	},
	{
		"value" : 1560,
		"label" : "Washington",
		"countryid" : 233,
		"statecode" : "WA"
	},
	{
		"value" : 1561,
		"label" : "West Virginia",
		"countryid" : 233,
		"statecode" : "WV"
	},
	{
		"value" : 1562,
		"label" : "Wisconsin",
		"countryid" : 233,
		"statecode" : "WI"
	},
	{
		"value" : 1563,
		"label" : "Wyoming",
		"countryid" : 233,
		"statecode" : "WY"
	}
];